export const FEATURES = {
  // Inventory
   STOCK_MOVEMENT_FULL: [
    "stock.receipt.create",
    "stock.issue.create",
    "stock.return.create",
    "stock.adjustment.create",
    "stock.requisition.create",
    "stock.issuance.approve"
  ],

  // Requester - only requisition
  STOCK_MOVEMENT_PARTIAL: ["stock.requisition.create"],

  // Customers
  CUSTOMERS_VIEW: ["customers.view"],
  CUSTOMERS_MANAGE: ["customers.create", "customers.update"],

  // Crop Varieties
  CROP_VARIETIES_VIEW: ["crop_varieties.view"],
  CROP_VARIETIES_MANAGE: ["crop_varieties.create", "crop_varieties.update", "crop_varieties.delete"],
} as const satisfies Record<string, string[]>;

export type FeatureKey = keyof typeof FEATURES;